import { TimePeriod } from "./TimePeriodSelector";


export const getDayXAxis = (currentDate: Date) => {
  const dayStart = new Date(currentDate);
  dayStart.setHours(0, 0, 0, 0);
  const dayEnd = new Date(currentDate);
  dayEnd.setHours(24, 0, 0, 0);

  const twoHourMs = 2 * 60 * 60 * 1000;
  const startMs = dayStart.getTime();
  const endMs = dayEnd.getTime();
  const ticks = Array.from({ length: 13 }, (_, i) => startMs + i * twoHourMs);

  const tickFormatter = (value: number) => {
    const date = new Date(value);
    const hour = date.getHours();
    if (hour % 4 === 2) return '.';
    if (value === endMs) return '24';
    return hour.toString();
  };

  return {
    domain: [startMs, endMs] as [number, number],
    ticks,
    tickFormatter
  };
};

export const getPeriodCategoryKeys = (period: TimePeriod, currentDate: Date): string[] => {
  if (period === 'week') {
    return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  }
  if (period === 'month') {
    const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const endOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    const daysInMonth = endOfMonth.getDate();
    return Array.from({ length: daysInMonth }, (_, i) => (i + 1).toString());
  }
  if (period === 'year') {
    return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  }
  return [];
};

export const getXAxisTickFormatterForPeriod = (period: TimePeriod, currentDate: Date) => {
  return (value: string) => {
    if (period === 'month') {
      const dayNumber = parseInt(value);
      if (isNaN(dayNumber)) return value;
      const dateToCheck = new Date(currentDate.getFullYear(), currentDate.getMonth(), dayNumber);
      const isSunday = dateToCheck.getDay() === 0;
      return isSunday ? value : '';
    }
    return value;
  };
};


